"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
exports.breakpoints = {
    xs: 0,
    sm: 320,
    md: 768,
    lg: 1240,
};
//# sourceMappingURL=breakpoints.js.map